export default __webpack_public_path__ + "static/media/enlarge_cursor_change_color_black_white.17dcab41.svg";